import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { CardTitle } from '@cargomatic/ui';
import CargomaticCollapsibleCard from 'components/v2/CollapsibleCard';
import OrdersActionCreators from '../../../actions/OrdersActionCreators';
import SendDOEmailModal from '../shipments/SendDOEmailModal';
import { Documents } from '../documents/Documents';
import AdminServerActionCreators from '../../../actions/AdminServerActionCreators';
import { orderDocTypes } from '../../../config/documents';
import { ShipmentDocumentList } from './ShipmentDocumentList';
export const OrderDocuments = ({ order, shipments }) => {
    const { t } = useTranslation();
    const [showEmailDeliveryOrderModal, setShowEmailDeliveryOrderModal] = useState(false);
    const [selectedDocumentId, setSelectedDocumentId] = useState(null);
    const handleSendEmails = (emails) => {
        OrdersActionCreators.emailCustomDeliveryOrder(order._id, selectedDocumentId, emails);
    };
    const handleShowEmailDeliveryOrderModal = (documentId) => {
        setShowEmailDeliveryOrderModal(true);
        setSelectedDocumentId(documentId);
    };
    const handleHideEmailDeliveryOrderModal = () => {
        setShowEmailDeliveryOrderModal(false);
        setSelectedDocumentId(null);
    };
    return (React.createElement(CargomaticCollapsibleCard, { id: "order-documents", header: () => React.createElement("span", null, t('ORDER_DOCUMENTS')) },
        React.createElement("div", null,
            React.createElement(Documents, { shipment: order, isOrder: true, onEmail: handleShowEmailDeliveryOrderModal, onUpload: (order, _) => {
                    AdminServerActionCreators.uploadOrderDocumentSuccess(order);
                }, onUploadFailed: (order, _, e) => {
                    AdminServerActionCreators.uploadOrderDocumentFail({
                        error: e === null || e === void 0 ? void 0 : e.message,
                    });
                }, shipments: shipments, docTypes: orderDocTypes, pageNeighbours: 0 })),
        React.createElement("div", { className: "mt-6 mb-4" },
            React.createElement(CardTitle, null, t('ASSOCIATED_SHIPMENT_DOCS'))),
        React.createElement(ShipmentDocumentList, { shipments: shipments }),
        showEmailDeliveryOrderModal && (React.createElement(SendDOEmailModal, { show: showEmailDeliveryOrderModal, onSend: handleSendEmails, onHide: handleHideEmailDeliveryOrderModal }))));
};
OrderDocuments.propTypes = {
    order: PropTypes.object,
};
